import {useEffect, useState} from 'react';
import {DetailGrid, wdiCore} from '@/components/GridWidget';
import {NsGrid} from '@/components/GridWidget/GridDefProps';
import {WdiCardTitle, WdiModalProps} from '@/components/WdiControls';
import {initFieldDisplayFormater} from '@/components/WdiBus/TableColumnRanderFormats'
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {Enum} from '@/enums/system';
import {GridApi} from '@/services/gridapi';
import {isDiscountContract, isInDirectContract} from "@/pages/contract/SalesContract/components/data";
import {Button, Space} from "antd";
import FormSalesContractTermsCompareModalApp
  from "@/pages/contract/FormSalesContractApproval/components/FormSalesContractTermsCompare";
import {FormSalesContract} from "@/services/contract/formsalescontract";
import {toExcel} from '@/components/WdiControls/WdiExcel';

export type DetailForApprovalProps = {
  data?: {
    form?: API.Form,
    formSalesContract?: API.FormSalesContract,
  },
  pageTypeId?: number;
  getHeaderInfo?: () => any;
  dataSource?: any[];
  onChange?: (dataSource: any) => void;
};

const SalesContractTermsForApproval: React.FC<DetailForApprovalProps> = (props) => {
  // Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const {pageTypeId, dataSource} = props;

  useEffect(() => {
    let formDefID = "SalesContractTermsForApproval";
    if (isInDirectContract(pageTypeId)) {
      formDefID = "SalesContractTerms2ForApproval";
    }
    if (isDiscountContract(pageTypeId)) {
      formDefID = "SalesContractTerms3ForApproval";
    }
    GridApi.searchConfig({id: formDefID, allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        rowKey: 'uid',
        actionsAlign: NsGrid.ActionsAlign.None,
        showExpandedRow: true,
      });
      settings.formSchema.allFields.rowNumber.getDisplayFormater = (_t: any, record: any, index: any) => {
        return `${record.rowNumber || index + 1}`;
      };
      initFieldDisplayFormater(settings.formSchema.allFields);
      settings.formSchema.allFields.rowNumber.width = 50;
      settings.formSchema.allFields.ecName.width = 150;
      settings.formSchema.allFields.processModeName.width = 100;
      settings.formSchema.allFields.revenueTypeName.width = 160;
      settings.formSchema.allFields.productNamesRebate.width = 250;
      settings.formSchema.allFields.settlementFrequencyName.width = 80;
      settings.formSchema.allFields.termsDesc.width = 180;

      settings.formSchema.allFields.rateOriginal.width = 120;
      settings.formSchema.allFields.productNamesReach.width = 100;
      settings.formSchema.allFields.remark.width = 100;
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);
  let maxAllowedFields = ['productNamesReach', 'rateOriginal', 'quantityForecast', 'termsAmount', 'termDescribe', 'remark', 'isConditional'];
  if (isInDirectContract(pageTypeId)) {
    maxAllowedFields = ['productNamesReach', 'rateOriginal', 'quantityForecast', 'termsAmount', 'rateDealer', 'termsAmountDealer', 'termDescribe', 'remark', 'isConditional'];
  } else if (isDiscountContract(pageTypeId)) {
    maxAllowedFields = ['productNamesRebate', 'shopName', 'rateOriginal', 'quantityForecast', 'remark', 'isConditional'];
  }
  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return maxAllowedFields;
    },
  };

  return (
    <WdiPanel collapsed={true} title={<WdiCardTitle iconType={Enum.IconType.CONTRACT_TERM} title='合同条款'/>}>
      {
        isLoaded &&
        <DetailGrid {...pageGridSettings} autoColumn={['rowNumber']}/>
      }
    </WdiPanel>
  );
};
export default SalesContractTermsForApproval;

export const SalesContractTermsForApprovalPanel: React.FC<DetailForApprovalProps> = (props) => {

  /// Grid初始化配置，GridSettings请求完数据之后再进行加载
  const [isLoaded, setIsLoaded] = useState(false);
  const [gridSettings, setGridSettings] = useState<any>({});
  const [modalProps, setModalProps] = useState<WdiModalProps>({visible: false});

  useEffect(() => {
    let formDefID = 'FormSalesContractTerms';
    if (props.pageTypeId) {
      if (isInDirectContract(props.pageTypeId)) {
        formDefID = 'FormSalesContractTerms2';
      } else if (isDiscountContract(props.pageTypeId)) {
        formDefID = 'FormSalesContractTerms3';
      }
    }
    GridApi.searchConfig({id: formDefID, allowModifyColumns: true}).then((response) => {
      const settings: any = Object.assign({}, response.data, {
        actionsAlign: NsGrid.ActionsAlign.None,
        showExpandedRow: true,
      });

      initFieldDisplayFormater(settings.formSchema.allFields);

      settings.formSchema.allFields.rowNumber.getDisplayFormater = (_t: any, record: any, index: any) => {
        return `${record.rowNumber || index + 1}`;
      };

      settings.formSchema.allFields.rowNumber.width = 50;
      setGridSettings(settings);
      setIsLoaded(true);
    });
  }, []);

  let maxAllowedFields = ['productNamesReach', 'rateOriginal', 'quantityForecast', 'revenueForecast', 'termsAmount', 'termDescribe', 'remark', 'isConditional'];
  if (isInDirectContract(props.pageTypeId)) {
    maxAllowedFields = ['productNamesReach', 'rateOriginal', 'quantityForecast', 'revenueForecast', 'termsAmount', 'rateDealer', 'termsAmountDealer', 'termDescribe', 'remark', 'isConditional'];
  } else if (isDiscountContract(props.pageTypeId)) {
    maxAllowedFields = ['productNamesRebate', 'shopName', 'rateOriginal', 'quantityForecast', 'remark', 'isConditional'];
  }
  const {dataSource, data} = props;
  const pageGridSettings = Object.assign({}, gridSettings);
  pageGridSettings.antdProps = {
    dataSource,
    initRowFieldConfigs: (record: any) => {
      return maxAllowedFields;
    },
  };

  const exportTerms = () => {
    let columns = [
      {name: "rowNumber", displayName: "行号"},
      {name: "ecName", displayName: "费用项名称"},
      {name: "processModeName", displayName: "条款类型"},
      {name: "revenueTypeName", displayName: "核算类型"},
      {name: "productNamesReach", displayName: "达量产品"},
      {name: "productNamesRebate", displayName: "返利产品"},
      {name: "settlementFrequencyName", displayName: "结案频率"},
      {name: "termsDesc", displayName: "返利坎级(ELN承担)"},
      {name: "quantityForecast", displayName: "预估销量(听)"},
      {name: "revenueForecast", displayName: "预估销售额（不含税）"},
      {name: "termsAmount", displayName: "固定金额"},
      {name: "rateForecast", displayName: "ELN预估承担点数"},
      {name: "rateOriginal", displayName: "初始比例"},
      {name: "rateDealer", displayName: "经销商承担点数"},
      {name: "termsAmountDealer", displayName: "经销商承担金额"},
      {name: "remark", displayName: "条款备注"},
      {name: "termDescribe", displayName: "细项描述"},
      {name: "isConditional", displayName: "是否有条件", type: Enum.FieldType.BOOLEAN}
    ];
    if (isDiscountContract(data?.form?.pageTypeId)) {
      columns = [
        {name: "rowNumber", displayName: "行号"},
        {name: "ecName", displayName: "费用项名称"},
        {name: "productNamesRebate", displayName: "返利产品"},
        {name: "settlementFrequencyName", displayName: "结案频率"},
        {name: "shopCode", displayName: "门店编码"},
        {name: "shopName", displayName: "门店名称"},
        {name: "unitCost", displayName: "单听费用"},
        {name: "quantityForecast", displayName: "预估销量(听)"},
        {name: "remark", displayName: "备注"},
        {name: "isConditional", displayName: "是否有条件", type: Enum.FieldType.BOOLEAN}
      ];
    }
    FormSalesContract.exportFormSalesContractTerms(Number(data?.form?.formId)).then(response => {
      const formSASheet = {
        data: response?.data,
        names: columns,
        sheetName: "合同条款明细",
        cells: {
          rateForecast: (fieldObject: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Number.RateToString(value);
            }
            return "";
          },
          rateOriginal: (fieldObject: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Number.RateToString(value);
            }
            return "";
          },
          rateDealer: (fieldObject: any, row: any, value: any) => {
            if (value) {
              return wdiCore.Number.RateToString(value);
            }
            return "";
          }
        }
      };
      toExcel({
        name: "合同条款明细_" + wdiCore.Date.ToString(new Date()) + ".xlsx",
        sheetProps: [formSASheet]
      });
    });
  };

  return (
    <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='合同条款'/>} extra={
      <Space>
        {!isDiscountContract(props.data?.form?.pageTypeId) && (<Button
          onClick={(e) => {
            e.stopPropagation();
            let url = DATA_DECISION_URL + "/form_no eq '" + props.data?.form?.formNo + "'";
            window.open(url);
          }}
          type='primary'>
          决策平台链接
        </Button>)}
        <Button type='primary' onClick={(e) => {
          e.stopPropagation();
          exportTerms();
        }}>
          导出
        </Button>
        <Button
          hidden={data?.formSalesContract?.createOrModify != 2}
          onClick={(e) => {
            e.stopPropagation();
            setModalProps({
              title: "合同变更对比",
              data: {form: data?.form, formSalesContract: data?.formSalesContract}, ...modalProps, ...{visible: true}
            });
          }}
          type='primary'>
          变更对比
        </Button>
      </Space>
    }>
      {isLoaded
        && modalProps.visible
        && data?.formSalesContract
        && <FormSalesContractTermsCompareModalApp {...modalProps} onClose={() => {
          setModalProps({...modalProps, ...{visible: false}});
        }}/>}
      {isLoaded && <DetailGrid {...pageGridSettings} />}
    </WdiPanel>
  );
};

